// src/components/common/PasswordGeneratorInput.js

import React from 'react';
import PasswordInput from './PasswordInput';
import { generateSecurePassword } from '../../utils/passwordGenerator'; // Vamos criar este arquivo em seguida.

export default function PasswordGeneratorInput({ id, name, value, onChange, placeholder }) {
    const handleGenerateClick = () => {
        const newPassword = generateSecurePassword();
        const syntheticEvent = {
            target: {
                name: name,
                value: newPassword,
            },
        };
        onChange(syntheticEvent);
    };

    return (
        <div className="relative">
            <PasswordInput
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
            />
            <button
                type="button"
                onClick={handleGenerateClick}
                className="absolute inset-y-0 right-10 flex items-center p-2 text-slate-400 hover:text-cyan-300"
                title="Gerar senha segura"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
                </svg>
            </button>
        </div>
    );
}